module.exports = __webpack_public_path__ + "img/tools_news_banner.ebfb1d19.jpg";